import React, { useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img from '../Assets/Container.png'
import icon from '../Assets/Link.png'
import { Create_Api } from '../API/Api_Url'
import { toast } from 'react-toastify'
function Contact() {

  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Number, setNumber] = useState('');
  const [Message, setMessage] = useState('');

  const [IsUploading, setIsUploading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!Name) newErrors.Name = 'Name is required.';

    if (!Email) newErrors.Email = 'Email is required.';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Email))
      newErrors.Email = 'Please enter a valid email address.';

    if (!Number) newErrors.Number = 'Mobile number is required.';
    else if (!/^\d{10}$/.test(Number))
      newErrors.Number = 'Mobile number must be exactly 10 digits.';

    if (!Message) newErrors.Message = 'Message is required.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async () => {
    try {
      if (!validateForm()) return;

      const data = {
        Name,
        Email,
        Number,
        Message
      };

      setIsUploading(true);

      const response = await Create_Api(`api/admin/CreateContactUs`, data);

      toast.success(response?.message);
      setName('');
      setEmail('');
      setNumber('');
      setMessage('');

    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.error(error);
    } finally {
      setIsUploading(false);
    }
  };



  return (
    <>
      <Navbar />
      <div className='project-banner'>
        <div className='pj-div'>
          <div className='pj-div-left'>
            <h3>Contact Us</h3>
          </div>
          {/* <div className='pj-div-right'>
            <p>Post your construction or renovation requirements and get connected with our network of Professionals.</p>
            <button>Post your requirement</button>
          </div> */}
        </div>
        <br />
        <br />
        <div className='pj-imgs'>
          <img className='pj-imgs-img' src={img} />
          <img className='pj-imgs-role' src={icon} />
        </div>

      </div>
      <div className='contact-div'>
        <div className='contact-div-left'>
          <div className='info-contact'>
            <div>
              <div className='circle'>
                <i class="bi bi-telephone-fill"></i>
              </div>
            </div>
            <div>
              <h4>Call</h4>
              <p><a href="tel:+919632114182">+91 9632114182</a></p>
            </div>
          </div>

          <div className='info-contact'>
            <div>
              <div className='circle'>
                <i class="bi bi-geo-alt-fill"></i>
              </div>
            </div>
            <div>
              <h4>Address</h4>
              <p>Bangalore</p>
            </div>
          </div>

          <div className='info-contact'>
            <div>
              <div className='circle'>
                <i class="bi bi-envelope-fill"></i>
              </div>
            </div>
            <div>
              <h4>E-mail</h4>
              <p><a href="mailto:info@professionalhouse.in">info@professionalhouse.in</a></p>
            </div>
          </div>
          <div className='info-contact'>
            <div>
              <div className='circle'>
                <i class="bi bi-globe2"></i>
              </div>
            </div>
            <div>
              <h4>Website</h4>
              <p>
                <a href="http://www.professionalhouse.in" target="_blank" rel="noopener noreferrer">
                  www.professionalhouse.in
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className='contact-div-right'>
          <div className='form'>
            <h3>Get In Touch</h3>
            <p>Post your construction or renovation requirements and get connected with our network of Professionals.</p>
            <div>
              <div></div>
              <label>Name</label>
              <input
                value={Name}
                onChange={(e) => setName(e.target.value)}
              />
              {errors.Name && <span className="error">{errors.Name}</span>}
            </div>
            <div>
              <label>Email</label>
              <input
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.Email && <span className="error">{errors.Email}</span>}
            </div>
            <div>
              <label>Mobile</label>
              <input
                value={Number}
                onChange={(e) => setNumber(e.target.value)}
              />
              {errors.Number && <span className="error">{errors.Number}</span>}
            </div>
            <div>
              <label>Message</label>
              <textarea
                value={Message}
                onChange={(e) => setMessage(e.target.value)}
              />
              {errors.Message && <span className="error">{errors.Message}</span>}
            </div>
            <br />
            <button onClick={handleSubmit} disabled={IsUploading}>
              {IsUploading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Contact